import { render, staticRenderFns } from "./bottomRight1.vue?vue&type=template&id=b1eb239c&scoped=true&"
import script from "./bottomRight1.vue?vue&type=script&lang=js&"
export * from "./bottomRight1.vue?vue&type=script&lang=js&"
import style0 from "./bottomRight1.vue?vue&type=style&index=0&id=b1eb239c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1eb239c",
  null
  
)

export default component.exports